// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CardWrapper_cardWrapper__5gIJ2"};